import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";

export default function PharmacistDashboard() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axiosInstance
      .get("internal-pharmacist/summary/")
      .then(res => setData(res.data))
      .catch(err => {
        console.log("Dashboard Error:", err.response?.data);
        alert("Failed to load dashboard");
      });
  }, []);

  if (!data) return <p>Loading...</p>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Internal Pharmacist Dashboard</h2>

      <div style={{ display: "flex", gap: 20, marginTop: 20 }}>
        <Card title="Pending" value={data.pending} />
        <Card title="Completed" value={data.completed} />
        <Card title="Rejected" value={data.rejected} />
        <Card title="Salary" value={`₹${data.salary}`} />
      </div>

      <button
        style={{
          marginTop: 30,
          padding: "10px 20px",
          border: "1px solid black",
          cursor: "pointer"
        }}
        onClick={() => navigate("/pharmacist-rx-dashboard")}
      >
        VIEW STATUS
      </button>
    </div>
  );
}

function Card({ title, value }) {
  return (
    <div style={{
      flex: 1,
      padding: 20,
      background: "#fff",
      borderRadius: 8,
      textAlign: "center",
      boxShadow: "0 0 5px #ccc"
    }}>
      <h3>{title}</h3>
      <h2>{value}</h2>
    </div>
  );
}
